import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import onboardingNavigationStore from "../../stores/onboarding-navigation-store";
import "./onboarding-default-navigation-controls.scss";

interface IDefaultNavigationControlsType {
    isBackDisabled?: boolean;
    isNextDisabled?: boolean;
    backText?: string;
    nextText?: string;
    onBackClick?: () => void;
    onNextClick?: () => void;
    isLoading?: boolean;
};

const OnboardingDefaultNavigationControls: React.FC<IDefaultNavigationControlsType> = ({
    isBackDisabled,
    isNextDisabled,
    backText,
    nextText,
    onBackClick,
    onNextClick,
    isLoading,
}: IDefaultNavigationControlsType) => {
    const scope = "dashboard-onboarding"; 
    const { getTranslation } = useDashboardTranslation();

    return (
        <div className="onboarding-wizard-default-nav-buttons">
            {onBackClick &&
                <div className="onboarding-wizard-nav-buttons-back">
                    <Button
                        text={backText ?? getTranslation('BACK', scope)}
                        variant={BUTTON_VARIANTS.Transparent}
                        disabled={isBackDisabled}
                        onClick={onBackClick}
                    />
                </div>
            }
            {onNextClick &&
                <div className="onboarding-wizard-nav-buttons-with-link">
                    <div className="onboarding-wizard-nav-buttons-continue">
                        <Button
                            text={nextText ?? getTranslation('CONTINUE_ONBOARDING', scope)}
                            variant={BUTTON_VARIANTS.PrimaryAccent}
                            disabled={isNextDisabled}
                            onClick={onNextClick}
                            hasLoader={true}
                            isLoading={isLoading?? false}
                        />
                    </div>
                    <div className="onboarding-wizard-nav-buttons-support-link" onClick={() => onboardingNavigationStore.openSupportChat()}>
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('NEED_HELP', scope)}</FontBody1>
                        <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.UNDER_LINE}>{getTranslation('TALK_TO_SUPPORT', scope)}</FontBody1>
                    </div>
                </div>
            }
        </div>
    );
}

export default OnboardingDefaultNavigationControls;